<ng-container *ngIf="route">
    <div class="route-segment-container-{{route.T}}">
        <!--czas -->
        <div class="route-times" *ngIf="route.T === 1">
            <div class="route-times__start-time">{{EndDateTime | date:'shortTime' }} </div>
            <!-- <div class="route-times_indicator">

            </div> -->
            <div class="route-times__end-time">{{StartDateTime | date:'shortTime' }} </div>
        </div>

        <!-- Czas trwania przejazdu -->
        <div class="route-duration" *ngIf="route.T === 0 || route.T === 3">
            <div class="route-duration__time">
                {{ route.St | timeDifference : (route.T === 3 ? currentDateISO : route.En) }}
            </div>
        </div>

        <!-- linia-->
        <div class="route-segment__bar">
            <!-- <div class="route-times_indicator_point"></div> -->
            <div *ngIf="route.T === 3" class="route-segment__bar__drive-icon">
                <i class="pi pi-angle-up"></i>
            </div>
            <div *ngIf="route.T === 1" class="route-segment__bar__parking-icon">
                <img src="/assets/images/map/white-stop-icon.svg" alt="">
            </div>
            <div *ngIf="route.T === 0" class="route-segment__bar__route-icon">
                <i class="pi pi-angle-up"></i>
            </div>
        </div>

        <!-- OPIS-->
        <div class="route-segment__description">
            <div class="upper-block">
                <span>{{Description}}</span>
                <!-- <ng-container *ngIf="Duration">
                    <span *ngIf="Description" class="point"></span>
                    <span>{{Duration | statusTimeFormat}}</span>
                </ng-container> -->
            </div>
            <div class="lower-block">
                <tk-vehicle-location [location]="Description2"></tk-vehicle-location>
            </div>
        </div>
    </div>
</ng-container>